"use strict";
module.exports = {
    entityModel: 'purchaseOrder',
    events: {
        PURCHASE_ORDER_SENT_TO_SUPPLIER: 'PURCHASE_ORDER_SENT_TO_SUPPLIER',
        PURCHASE_ORDER_DELIVERY_RECEIVED: 'PURCHASE_ORDER_DELIVERY_RECEIVED',
        PURCHASE_ORDER_DELIVERY_PROCESSED: 'PURCHASE_ORDER_DELIVERY_PROCESSED',
        PURCHASE_ORDER_SENT: 'PURCHASE_ORDER_SENT',
        PURCHASE_ORDER_EMCS_DOWNLOADED: 'PURCHASE_ORDER_EMCS_DOWNLOADED',
        PURCHASE_ORDER_REQUESTED: 'PURCHASE_ORDER_REQUESTED',
        PURCHASE_ORDER_CANCELLED: 'PURCHASE_ORDER_CANCELLED',
        PURCHASE_ORDER_UPDATED: 'PURCHASE_ORDER_UPDATED',
        PURCHASE_ORDER_CREATED: 'PURCHASE_ORDER_CREATED',
    },
    actions: {
        get: 'v1.purchaseOrder.get',
        list: 'v1.purchaseOrder.list',
        writeOrder: 'v1.purchaseOrder.writeOrder',
        placeOrder: 'v1.purchaseOrder.placeOrder',
        addRemark: 'v1.purchaseOrder.addRemark',
        setArcNumber: 'v1.purchaseOrder.setArcNumber',
        markAsEmcsProcessed: 'v1.purchaseOrder.markAsEmcsProcessed',
        sendToSupplier: 'v1.purchaseOrder.sendToSupplier',
        resendOrder: 'v1.purchaseOrder.resendOrder',
        shipOrder: 'v1.purchaseOrder.shipOrder',
        markAsReceived: 'v1.purchaseOrder.markAsReceived',
        cancel: 'v1.purchaseOrder.cancel',
        removeRow: 'v1.purchaseOrder.removeRow',
        removeSuggestionRows: 'v1.purchaseOrder.removeSuggestionRows',
        resupplyArticle: 'v1.purchaseOrder.resupplyArticle',
        changeDeliveryDate: 'v1.purchaseOrder.changeDeliveryDate',
        processDelivery: 'v1.purchaseOrder.processDelivery',
        ensureInvariants: 'v1.purchaseOrder.ensureInvariants',
        downloadEMCS: 'v1.purchaseOrder.downloadEMCS',
        upsert: 'v1.purchaseOrder.upsert',
        upsertWhenEmpty: 'v1.purchaseOrder.upsertWhenEmpty',
        updateWhenEmpty: 'v1.purchaseOrder.updateWhenEmpty',
        update: 'v1.purchaseOrder.update',
    },
    purchaseOrderStates: {
        draft: 'draft',
        waitingForFlaivyApproval: 'waitingForFlaivyApproval',
        sentToSupplier: 'sentToSupplier',
        shipped: 'shipped',
        received: 'received',
        partialyDelivered: 'partialyDelivered',
        delivered: 'delivered',
    },
    targetWarehouses: {
        vinden: 'vinden',
        exacta: 'exacta',
    },
    purchaseOrderRows: {},
    purchaseOrderDeliveries: {},
};
